const state = {
    author: 'f2e'
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/demo/demo.js